import React from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import SelectWithClear from "Components/UI/Form/SelectWithClear";
import { FILECATEGORY } from "utils/options/FILECATEGORY";

export default function FilesFormGeneral({ formData, handleInputChange }) {
  return (
    <>
      <Grid container spacing={3} sx={{ marginTop: "5px" }}>
        <Grid item xs={12} md={4}>
          <TextField
            disabled
            name="Id"
            label="Id"
            value={formData.Id}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
            type="number"
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <FormControl fullWidth margin="dense" sx={{ textAlign: "left" }}>
            <SelectWithClear
              name="Category"
              label="Kategori"
              value={formData.Category}
              onChange={(e) => handleInputChange("Category", e.target.value)}
            >
              {FILECATEGORY.map((option) => (
                <MenuItem key={option.Value} value={option.Value}>
                  {option.Name}
                </MenuItem>
              ))}
            </SelectWithClear>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={4}>
          <TextField
            name="Name"
            onChange={(e) => handleInputChange("Name", e.target.value)}
            label="Namn"
            value={formData.Name}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
            type="text"
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <TextField
            name="FileType"
            disabled
            onChange={(e) => handleInputChange("FileType", e.target.value)}
            label="Filtyp"
            value={formData.FileType}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
            type="string"
          />
        </Grid>
      </Grid>
    </>
  );
}
